import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Scrollable } from '@sorare/core/src/atoms/navigation/Scrollable';
import { LabelM } from '@sorare/core/src/atoms/typography';

import {
  Block,
  PlayerDrawerTokenSkeleton,
} from '#src/components/player/PlayerMarketDrawer/ui.tsx';
import { PlayerDrawerToken } from '#src/components/token/PlayerDrawerToken/index.tsx';

import type { PlayerMarketDrawerAuctions_anyCard } from './__generated__/index.graphql.ts';

type Props = {
  slugs: string[];
  anyCards: PlayerMarketDrawerAuctions_anyCard[];
  canUseConversionCredit?: boolean;
};

const PlayerDrawerAuctionSkeleton = styled(PlayerDrawerTokenSkeleton)`
  height: calc(19.5 * var(--unit));
`;

export const Auctions = ({
  slugs,
  anyCards,
  canUseConversionCredit,
}: Props) => {
  if (slugs.length === 0) return null;
  return (
    <Block>
      <LabelM color="var(--c-nd-600)">
        <FormattedMessage defaultMessage="Auctions" />
      </LabelM>
      <Scrollable itemToDisplay={1} itemGap={2}>
        {slugs.map(slug => {
          const anyCard = anyCards.find(ac => ac.slug === slug);
          if (!anyCard) return <PlayerDrawerAuctionSkeleton key={slug} />;
          return (
            <PlayerDrawerToken
              key={anyCard.slug}
              anyCard={anyCard}
              canUseConversionCredit={canUseConversionCredit}
            />
          );
        })}
      </Scrollable>
    </Block>
  );
};

Auctions.fragments = {
  anyCard: gql`
    fragment PlayerMarketDrawerAuctions_anyCard on AnyCardInterface {
      slug
      ...PlayerDrawerToken_anyCard
    }
    ${PlayerDrawerToken.fragments.anyCard}
  ` as TypedDocumentNode<PlayerMarketDrawerAuctions_anyCard>,
};
